import React, { useState } from "react";
import ModalListaDeSuministros from "./ModalListaDeSuministros";

import ModalSeleccionPaquetes from "./ModalSeleccionPaquetes";

const ModalSeleccionTipoSuministro = ({
  setmodalOnSeleccionTipoSuministro,
}) => {
  const [seleccionarTipoSuministro, setseleccionarTipoSuministro] = useState(0);
  const [modalOnSeleccionardePaquete, setmodalOnSeleccionardePaquete]= useState(false)
  const [modalOnListaSuministros, setmodalOnListaSuministros] = useState(false)

  const handleOnchangeTipoSuministro = (e) => {
    setseleccionarTipoSuministro(e.target.value);
    
  };

  const onClickSeleccionarTipoSuministro =()=>{    
    setmodalOnSeleccionardePaquete(true)
    if(seleccionarTipoSuministro == "1"){      
      setmodalOnSeleccionardePaquete(true)
    }else if(seleccionarTipoSuministro == "2"){
      setmodalOnListaSuministros(true)
    }
  }

  const handleCancelarClick = () => {
    setmodalOnSeleccionTipoSuministro(false);
  };
  return (
    <>
      <div
        className="z-40 fixed top-0 left-0 w-full h-full outline-none overflow-x-hidden overflow-y-auto pt-20"
        id="exampleModalScrollable"
        tabIndex="-1"
        aria-labelledby="exampleModalScrollableLabel"
        aria-hidden="true"
      >
        <div className="sm:h-[calc(100%-3rem)] max-w-xl my-6 mx-auto relative w-auto pointer-events-none ">
          <div className="max-h-full overflow-hidden border-none shadow-lg relative flex flex-col w-full pointer-events-auto bg-white bg-clip-padding rounded-md outline-none text-current">
            <div className="flex flex-shrink-0 items-center justify-between p-2 border-b border-gray-200 rounded-t-md  ">
              <h5
                className="text-xl font-medium leading-normal text-gray-800"
                id="exampleModalScrollableLabel"
              >
                Selección Tipo Paquete 
              </h5>
              <button
                type="button"
                onClick={handleCancelarClick}
                className="btn-close box-content w-4 h-4 p-1 text-black border-none rounded-none opacity-50 focus:shadow-none focus:outline-none focus:opacity-100 hover:text-black hover:opacity-75 hover:no-underline"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                X
              </button>
            </div>

            <div className="mt-3 text-center p-20">
              <div className="flex justify-center">
                <div>
                  <div className="form-check">
                    <input
                      className="form-check-input appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault1"
                      value="1"
                      checked={seleccionarTipoSuministro == 1 ? true:false}
                      onChange={handleOnchangeTipoSuministro}
                    />
                    <label
                      className="form-check-label inline-block text-gray-800"
                      htmlFor="flexRadioDefault1"
                    >
                      Paquetes
                    </label>
                  </div>
                  <div className="form-check">
                    <input
                      className="form-check-input appearance-none rounded-full h-4 w-4 border border-gray-300 bg-white checked:bg-blue-600 checked:border-blue-600 focus:outline-none transition duration-200 mt-1 align-top bg-no-repeat bg-center bg-contain float-left mr-2 cursor-pointer"
                      type="radio"
                      name="flexRadioDefault"
                      id="flexRadioDefault2"
                      value="2"
                      checked={seleccionarTipoSuministro == 2 ? true:false}
                      onChange={handleOnchangeTipoSuministro}
                    />
                    <label
                      className="form-check-label inline-block text-gray-800"
                      htmlFor="flexRadioDefault2"
                    >
                      Suministro 
                    </label>
                  </div>
                  
                </div>
              </div>
            </div>
            <div className="flex flex-shrink-0 flex-wrap items-center justify-end p-4 border-t border-gray-200 rounded-b-md">
              <button
                type="button"
                onClick={handleCancelarClick}
                className="inline-block px-6 py-2.5 bg-purple-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-purple-700 hover:shadow-lg focus:bg-purple-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-purple-800 active:shadow-lg transition duration-150 ease-in-out"
                data-bs-dismiss="modal"
              >
                Cancelar
              </button>
              <button
                onClick={onClickSeleccionarTipoSuministro}
                type="button"
                className="inline-block px-6 py-2.5 bg-blue-600 text-white font-medium text-xs leading-tight uppercase rounded shadow-md hover:bg-blue-700 hover:shadow-lg focus:bg-blue-700 focus:shadow-lg focus:outline-none focus:ring-0 active:bg-blue-800 active:shadow-lg transition duration-150 ease-in-out ml-1"
              >
                Abrir
              </button>
            </div>
          </div>
        </div>
      </div>
      {modalOnSeleccionardePaquete? <ModalSeleccionPaquetes setmodalOnSeleccionardePaquete={setmodalOnSeleccionardePaquete}/>:null}
      {modalOnListaSuministros? <ModalListaDeSuministros setmodalOnListaSuministros={setmodalOnListaSuministros}/>:null}
     
    </>
  );
};

export default ModalSeleccionTipoSuministro;
